import { useMediaQuery, useTheme } from '@mui/material';

export function useIsMobile() {
  const theme = useTheme();
  const isNarrowScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumTouchScreen = useMediaQuery('(max-width:899.95px) and (pointer: coarse)');
  return isNarrowScreen || isMediumTouchScreen;
}
